import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';

interface SectionHeadingProps {
  eyebrow?: string;
  title: string;
  description?: string;
  action?: { label: string; to: string };
  children?: ReactNode;
}

export default function SectionHeading({ eyebrow, title, description, action }: SectionHeadingProps) {
  return (
    <div className="mb-6 flex flex-col gap-3 sm:flex-row sm:items-end sm:justify-between">
      <div>
        {eyebrow && (
          <span className="mb-2 flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.18em] text-accent-600">
            <span className="h-2 w-2 rounded-full bg-accent-500" />
            {eyebrow}
          </span>
        )}
        <h2 className="font-heading text-xl font-bold text-foreground-950 md:text-2xl">{title}</h2>
        {description && <p className="mt-2 max-w-2xl text-sm text-foreground-500">{description}</p>}
      </div>
      {action && (
        <Link
          to={action.to}
          className="flex w-fit cursor-pointer items-center gap-1 whitespace-nowrap rounded-md border border-background-200 px-3 py-2 text-sm text-foreground-600 transition-colors hover:border-primary-300 hover:text-primary-700"
        >
          {action.label}
          <i className="ri-arrow-right-line text-base" />
        </Link>
      )}
    </div>
  );
}